import { useState, useCallback } from 'react';
import Container from '@/components/Container';
import MarketingSection from './MarketingSection';

function MarketingFAQ({
  question,
  answer,
}) {
  const [isOpen, setOpen] = useState(false);

  const onClickCallback = useCallback(() => {
    setOpen((v) => !v);
  }, []);

  return (
    <div  className="flex flex-col border-t-2 border-gray-100">
      <button className="flex items-center w-full focus:outline-none py-6" onClick={onClickCallback} type="button">
        <h3 className="font-medium text-lg lg:text-xl flex-1 text-left">
          {question}
        </h3>
        <svg className="w-6 h-6 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          {isOpen === false && (<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />)}
          {isOpen === true && (<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />)}
        </svg>
      </button>
      {isOpen && (
        <div
          className="prose lg:prose-lg pb-6"
          dangerouslySetInnerHTML={{ __html: answer }}
        />
      )}
    </div>
  );
}

export default function MarketingFAQs({
  faqs,
}) {
  return (
    <MarketingSection className="bg-white" sectionTitle="Preguntas más frecuentes">
      <Container maxWidth="max-w-screen-lg">
        <div className="flex flex-col">
          {faqs.map(({ question, answer }, index) => (
            <MarketingFAQ key={`faq-${index}`} question={question} answer={answer} />
          ))}
        </div>
      </Container>
    </MarketingSection>
  );
}
